import { render, staticRenderFns } from "./TransaksiGadai.vue?vue&type=template&id=a6e8ba3e&scoped=true&"
import script from "./TransaksiGadai.vue?vue&type=script&lang=js&"
export * from "./TransaksiGadai.vue?vue&type=script&lang=js&"
import style0 from "./TransaksiGadai.vue?vue&type=style&index=0&id=a6e8ba3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e8ba3e",
  null
  
)

export default component.exports